export default __webpack_public_path__ + "static/media/mini_lock.dd8e8983.svg";